import React from "react";

const CONTENT_TYPES = ["", "VIDEO", "PDF", "SCORM", "ARTICLE", "QUIZ", "EVALUATION"];
const SORTS = [
    { value: "RECENT", label: "Recent" },
    { value: "OLDEST", label: "Ancien" },
    { value: "CONTENT_TYPE", label: "Type contenu" },
];

export default function ModulePersonalNotesFilters({ filters, sections = [], onChange }) {
    const update = (patch) => onChange?.({ ...filters, ...patch });

    return (
        <div className="mpn-filters">
            <select value={filters.contentType || ""} onChange={(event) => update({ contentType: event.target.value })}>
                {CONTENT_TYPES.map((type) => (
                    <option key={type || "ALL"} value={type}>{type || "Tous les types"}</option>
                ))}
            </select>
            <select value={filters.sectionId || ""} onChange={(event) => update({ sectionId: event.target.value })}>
                <option value="">Toutes les sections</option>
                {sections.map((section) => (
                    <option key={section.id} value={section.id}>{section.title}</option>
                ))}
            </select>
            <select value={filters.sort || "RECENT"} onChange={(event) => update({ sort: event.target.value })}>
                {SORTS.map((sort) => (
                    <option key={sort.value} value={sort.value}>{sort.label}</option>
                ))}
            </select>
        </div>
    );
}
